// Plain-language "when can I try again" text. Nothing here ticks: the text is worked out once.

// 45 -> "less than a minute", 90 -> "about a minute", 840 -> "about 14 minutes", 3600 -> "about an hour"
export function waitPhrase(totalSeconds) {
  const s = Math.max(0, Math.ceil(Number(totalSeconds) || 0));
  if (s < 60) return "less than a minute";
  if (s < 120) return "about a minute";
  const minutes = Math.ceil(s / 60);
  if (minutes < 55) return `about ${minutes} minutes`;
  if (minutes <= 65) return "about an hour";
  const hours = Math.ceil(minutes / 60);
  return `about ${hours} hours`;
}

// The clock time the wait ends, in the student's own time zone: "3:42 PM"
export function clockTime(totalSeconds, now = Date.now()) {
  const when = new Date(now + Math.max(0, Number(totalSeconds) || 0) * 1000);
  return when.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

// "You can ask again in about 14 minutes (after 3:42 PM)." Short waits leave the clock time out.
export function askAgainText(totalSeconds, now = Date.now()) {
  const s = Math.max(0, Math.ceil(Number(totalSeconds) || 0));
  const phrase = waitPhrase(s);
  if (s < 120) return `You can ask again in ${phrase}.`;
  return `You can ask again in ${phrase} (after ${clockTime(s, now)}).`;
}

// Waits up to this long show a live countdown; longer ones (the hourly limit) show one fixed line.
export const LIVE_CLOCK_MAX_SECONDS = 120;

// 42 -> "42s", 105 -> "1:45"
export function shortCountdown(totalSeconds) {
  const s = Math.max(0, Math.ceil(Number(totalSeconds) || 0));
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

// The two dialogs accept either a word ("sent") or {status, retryAfter}; this makes them one shape.
export function normalizeResult(result) {
  if (result && typeof result === "object") {
    const retryAfter = Number(result.retryAfter);
    return { status: String(result.status || "error"), retryAfter: retryAfter > 0 ? retryAfter : undefined };
  }
  return { status: String(result || "error"), retryAfter: undefined };
}
